// FindIdPage.tsx
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {changePasswordAfter} from '../../api/authApi';
import {getAuthInfo} from "../../utils/authUtils";
import {defaultAlert} from "../../utils/alert";
import {handleLoginError} from "./LoginPage";
import axios, {AxiosError} from 'axios';

export default function LoginPasswordPage() {
    const navigate = useNavigate();

    const [memberId, setMemberId] = useState('');
    const isAxiosError = (error: unknown): error is AxiosError => {
        return axios.isAxiosError(error);
    };

    useEffect(() => {
        const authInfo = getAuthInfo();
        if(authInfo != null) {
            setMemberId(authInfo.memberId);
        }
    }, []);

    const handleNextTime = async () => {

        try {
            const res = await changePasswordAfter({memberId});

            const resultCode = res.data.code;

            if(resultCode == "00") {
                navigate("/");
            } else {
                defaultAlert(res.data?.message || '예기치 않은 오류가 발생했습니다.');
            }
        } catch (error) {
            if (isAxiosError(error)) {
                handleLoginError(error);
            } else {
                defaultAlert('예기치 않은 오류가 발생했습니다.');
                console.error('Unknown error:', error);
            }
        }
    };

    return (
        <div className="app">
            <div className="bottom-btn">
                <button id="" type="button" className="btn cancel" onClick={handleNextTime}>다음에 변경하기</button>
                <button id="" type="button" className="btn confirm"
                        onClick={() => navigate('/login-password-change', {
                                        state: {memberId, verified: true}
                })}>비밀번호 변경</button>
            </div>
            <main className="container">
                <section className="tit-box-wrap">
                    <h2 className="headline"><i className="fa-solid fa-unlock-keyhole pr-3 point"></i>비밀번호 변경</h2>
                    <p className="subtit">개인정보 보호를 위해 주기적인 <br/>비밀번호 변경을 권장하고 있습니다.</p>
                </section>
                <section>
                    <div className="inner-box">
                        <div className="guide-box">
                            <ul className="guidF-list">
                                <li>오래된 비밀번호를 변경하여 주세요.</li>
                                <li>다른 사이트와 동일한 비밀번호를 사용하지 않는 것이 더욱 안전합니다.</li>
                                <li>안전한 사용을 위해 <span className="strong">아래 비밀번호 변경하기 버튼을 눌러 비밀번호를 변경</span>해주세요.</li>
                            </ul>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}